<template>
  <user-login-wrapper>
    <el-card class="full-card" shadow="always">
      <template #header>
        <div v-if="detail != null">
          <jr-applicant-title
            titleName="近接工事申請件名詳細編集"
            :applicantNumber="detail.applicant_number"
            :applicantTitle="detail.applicant_title"
          />
        </div>
      </template>
      <template #default>
        <double-scroll :leftSpan="24">
          <template #left>
            <proximity-info
              :isEdit="true"
              :requestHeaderId="requestHeaderId"
              @update:form="detail = $event"
              :returnToList="false"
              :isActionBtnVisible="false"
              :isEditBtnVisible="true"
              :isHistoryTableVisible="false"
            />
          </template>
        </double-scroll>
      </template>
    </el-card>
  </user-login-wrapper>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue'
import UserLoginWrapper from '@/components/auth-wrappers/UserLoginWrapper.vue'
import ProximityInfo from '@/components/layout/ProximityInfo.vue'
import DoubleScroll from '@/components/layout/DoubleScroll.vue'
import { useRoute, useRouter } from 'vue-router'
import { RequestHeaderProximityForm } from '@/types/forms'
import Logger from '@/services/logger'
import JrApplicantTitle from '@/components/jr-parts/JrApplicantTitle.vue'

/**
 * 近接工事申請件名詳細編集
 */
export default defineComponent({
  name: 'ProximityEdit',
  components: {
    UserLoginWrapper,
    ProximityInfo,
    DoubleScroll,
    JrApplicantTitle,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const requestHeaderId = computed(() => {
      const id = Number(route.params.request_header_id)
      return Number.isNaN(id) ? false : id
    })
    if (!requestHeaderId.value) {
      Logger.info('URLパラメータが不正です。')
      router.push({ name: 'NotFound' })
    }
    const detail = ref<RequestHeaderProximityForm | null>(null)

    return {
      requestHeaderId,
      detail,
    }
  },
})
</script>

<style lang="scss" scoped>
.el-collapse {
  border-top: none;
  border-bottom: none;
}
.el-collapse-item {
  ::v-deep(.el-collapse-item__content) {
    padding-bottom: 0px !important;
  }
  ::v-deep(.el-collapse-item__wrap) {
    border-top: none !important;
    border-bottom: none !important;
  }
  ::v-deep(.el-collapse-item__header) {
    border-top: none !important;
    border-bottom: none !important;
  }
}
.action-buttons {
  flex-wrap: wrap;
  margin-left: -5px;
  margin-right: -5px;
  margin-top: -5px;
  padding-bottom: 10px;
  .el-button {
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 5px;
  }
}
.input-group-dark {
  margin-top: 8px;
  margin-bottom: 8px;
}
.right-panels {
  margin-top: -8px;
  margin-bottom: -8px;
}

.el-descriptions {
  ::v-deep(.el-descriptions__label) {
    width: 90px;
  }
}
</style>
